
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flokkur/[cslug]",
      function () {
        return require("private-next-pages/flokkur/[cslug]/index.tsx");
      }
    ]);
  